import React, { useState, useRef, useEffect } from 'react'
import { Button, DialogActions, DialogContent, DialogContentText, Menu, MenuItem, Select, Box } from '@mui/material';
import DatabaseIcon from '../../../assets/icons/Icon feather-database.svg'
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import DatasetJoinIcon from '../../../assets/icons/dataset-join-icon-2.png'

import { Handle } from 'react-flow-renderer';


import ReactFlow, {
  getBezierPath,
  getEdgeCenter,
  getMarkerEnd,
  removeElements,
  ReactFlowProvider,
  addEdge,
  MiniMap,
  Controls,
  ControlButton,
  Background,
  updateEdge
} from 'react-flow-renderer';
import toast from 'react-hot-toast';
import { getDataSetDetails } from '../../../config/services/datasets';
import Popup from '../../Popup';

const foreignObjectSize = 50;

//const onLoad = (reactFlowInstance) => reactFlowInstance.fitView();
const JoinPreview = ({ joinDatasets, setJoinDatasets, openDataSetPopUp, edgeClickHandler, primaryDataSetId, joinConfig, setJoinConfig, setCurrentJoinConfig, currentJoinConfig, setIsConfig, athenaTableData, setAthenaTableData, tableTabIndex, setTableTabIndex, setSelectedDatasetId, setSelectedTableName, selectedTableName, setDataSetFilter, setMeasureList, setFilterMeasureList, setShowTableData }) => {


  const reactFlowWrapper = useRef(null)
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [joinNodeMenuEl, setJoinNodeMenuEl] = useState(null);
  const [currentDatasetNode, setCurrentDatasetNode] = useState('')
  const [confirmDatasetDelete, setConfirmDatasetDelete] = useState(false)


  const handleNodeMenuClose = (id) => {
    setJoinNodeMenuEl(null);
  }

  const CustomEdge = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style = {}, data, arrowHeadType, markerEndId }) => {
    const edgePath = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });
    const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
    const [edgeCenterX, edgeCenterY] = getEdgeCenter({ sourceX, sourceY, targetX, targetY });

    return (
      <>
        <path
          id={id}
          style={style}
          className="react-flow__edge-path"
          d={edgePath}
          markerEnd={markerEnd}
        />
        <foreignObject
          width={foreignObjectSize * 2}
          height={foreignObjectSize * 2}
          x={edgeCenterX - foreignObjectSize / 2}
          y={edgeCenterY - foreignObjectSize / 2}
        >
          <Button
            className="edgebutton join_config_btn form_icon"
            onClick={(event) => onEdgeClick(event, id)}
          >
            <img src={DatasetJoinIcon} className="join_config_icon" alt="join_config"
            />
          </Button>
        </foreignObject>
      </>
    );
  }

  const onEdgeClick = (evt, id) => {
    evt.stopPropagation();
    edgeClickHandler(evt, id)
  }

  const edgeTypes = {
    buttonedge: CustomEdge,
  };


  const onEdgeUpdate = (oldEdge, newConnection) => {
    return setJoinDatasets((els) => updateEdge(oldEdge, newConnection, els))
  };


  ///////////////Custom Node//////////////////

  const CustomNode = ({ data, isConnectable }) => {


    const handleJoinNodeMenu = (e, id) => {
      //console.log(e,id)
      setCurrentDatasetNode(id)
      //setSelectedDatasetId(dataSetId)
      setJoinNodeMenuEl(e?.target)
    }

    return (
      <div className="join_custom_node" >
        <Box className='head-icon' ></Box>
        <Handle
          type="target"
          position="top"
          style={{ background: '#555' }}
          isConnectable={isConnectable}
        />
        <div className="join_node_content">
          <div className="join_node_content_info">
            <img src={DatabaseIcon} alt="" style={{ marginRight: '8px' }} />
            <p>{data?.label}</p>
          </div>
          {
            <Button className="form-icon-btn" onClick={e => handleJoinNodeMenu(e, data?.id)}><DropDownIcon /></Button>
          }
        </div>
        <Handle
          type="source"
          position="bottom"
          style={{ background: '#555' }}
          isConnectable={isConnectable}
        />
      </div>
    )
  }

  const nodeTypes = {
    CustomNode: CustomNode,
  };

  ////////////////////////////////////

  const handleSubmitDataSetChange = (data) => {
    switch (data.type) {
      case 'cancel':
        setConfirmDatasetDelete(false)
        break
      case 'change':
        handleElementsRemove()
        setConfirmDatasetDelete(false)
        break
    }

  }

  const onConnect = (params) => {
    params.type = 'buttonedge';
    params.id = `edge-${params?.source}-${params?.target}`
    const edgeData = joinDatasets.filter(ele => (ele.id).includes('edge'))
    const targetEdge = edgeData.find(ele => {
      let targetId = ele?.id.split('-')[2]
      if (targetId === params?.target) {
        return ele;
      }
    })
    for (let join = 0; join < joinDatasets.length; join++) {
      if (joinDatasets[join]?.id === targetEdge?.id) {
        joinDatasets.splice(join, 1)
        break;
      }
    }
    return setJoinDatasets((els) => addEdge(params, els));
  }

  const handleDatasetRemove = () => {
    const elementsToRemove = joinDatasets.filter(data => {
      if (data?.type === 'CustomNode' && data?.id === currentDatasetNode) {
        return data;
      }
      else if ((data?.type === 'buttonedge') && data?.source === currentDatasetNode || data?.target === currentDatasetNode) {
        return data;
      }
    })

    if (elementsToRemove && elementsToRemove.length) {
      const exist = elementsToRemove.find(ele => !ele?.id.includes('_') && ele?.id === primaryDataSetId)
      if (exist) {
        setJoinNodeMenuEl(null)
        toast.error('Primary Dataset cannot be removed')
        return
      }
      else {
        setConfirmDatasetDelete(true)
        setJoinNodeMenuEl(null)
      }
    }
  }

  const handleElementsRemove = () => {
    setJoinNodeMenuEl(null)
    let datasets = joinDatasets.filter(obj => (obj.id != currentDatasetNode && obj.type == 'CustomNode') || (obj.target != currentDatasetNode && obj.type == "buttonedge"))
    setJoinDatasets([...datasets])
  }

  const onNodeDragStop = (evt, node) => {
    let datasets = joinDatasets.map((join) => {
      if (join?.id === node?.id) {
        join.position = node?.position
      }
      return join
    })
    setJoinDatasets([...joinDatasets])
  }

  const handleSelectDataset = () => {
    setJoinNodeMenuEl(null);
    openDataSetPopUp()
  }

  useEffect(() => {
    setSelectedDatasetId(currentDatasetNode)
  }, [currentDatasetNode])


  return (
    <>
      <ReactFlow
        elements={joinDatasets}
        ref={reactFlowWrapper}
        //onLoad={onLoad}
        onNodeDragStop={onNodeDragStop}
        onEdgeUpdate={onEdgeUpdate}
        edgeTypes={edgeTypes}
        onConnect={onConnect}
        nodeTypes={nodeTypes}
        fitview="true"
      >
        <Background />
        <Controls />
      </ReactFlow>
      <Menu
        style={{ marginRight: '10px' }}
        id="simple-menu"
        anchorEl={joinNodeMenuEl}
        keepMounted
        open={Boolean(joinNodeMenuEl)}
        onClose={e => handleNodeMenuClose()}

      >
        <MenuItem className='menu-item' onClick={handleSelectDataset} value="remove">Add Dataset</MenuItem>
        <MenuItem className='menu-item' onClick={handleDatasetRemove} value="remove">Remove</MenuItem>
      </Menu>

      <Popup
        title={'Warning!'}
        openPopup={confirmDatasetDelete}
        setOpenPopup={() => handleSubmitDataSetChange({ type: 'cancel' })}
      >
        <DialogContent>
          <DialogContentText>
            Removing Dataset Will Reset Measures/Dimensions/Filters Selection. Are you sure to remove it?'
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button className='report_form_ui_btn cancel' onClick={() => handleSubmitDataSetChange({ type: 'cancel' })} color="error"> Cancel </Button>
          <Button className='report_form_ui_btn submit' onClick={() => handleSubmitDataSetChange({ type: 'change' })} color="primary" autoFocus> Remove </Button>
        </DialogActions>
      </Popup>


    </>
  );
}

export default JoinPreview

